export default __webpack_public_path__ + "static/media/axios.73c86045.png";